import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { PriceSort, PriceSortDirection } from 'src/app/models/results/price-sort';
import { ConfigService } from 'src/app/services/config/config.service';
import { SortingService } from 'src/app/services/results/sorting/sorting.service';

@Component({
  selector: 'app-price-sorting',
  templateUrl: './price-sorting.component.html',
  styleUrls: ['./price-sorting.component.scss']
})
export class PriceSortingComponent implements OnInit {
  @Output() changePriceSorting: EventEmitter<PriceSort> = new EventEmitter();

  @Input() totalResults!: number
  @Input() ammountResultsShown!: number

  currentPriceSort: PriceSort = new PriceSort(PriceSortDirection.LowToHigh);
  priceDisclaimerText: string = "";
  priceSortButtonPrefixText: string = "";
  priceLowToHighText: string = "";
  priceHighToLowText: string = "";
  priceSortButtonText: string = "";
  priceSortMobileTitle: string = "";
  showSortOptions: boolean = false;
  lowToHighSortDirection: PriceSortDirection = PriceSortDirection.LowToHigh;
  highToLowSortDirection: PriceSortDirection = PriceSortDirection.HighToLow;

  constructor(private sortingService: SortingService, private confSvc: ConfigService) { }

  async ngOnInit(): Promise<void> {
    await this.confSvc.setup();

    this.priceDisclaimerText = this.confSvc.getString("priceDisclaimerText");
    this.priceSortButtonPrefixText = this.confSvc.getString("priceSortButtonPrefixText");
    this.priceLowToHighText = this.confSvc.getString("priceLowToHighText");
    this.priceHighToLowText = this.confSvc.getString("priceHighToLowText");
    this.priceSortMobileTitle = this.confSvc.getString("priceSortMobileTitle");
    this.setPriceSortButtonText();

    this.sortingService.currentPriceSort$.subscribe((priceSort: PriceSort) => {
      if (this.isUpdatedPriceSort(priceSort.sortDirection)) {
        this.updateCurrentPriceSort(priceSort);
      }
    });
  }

  isUpdatedPriceSort(direction: PriceSortDirection): boolean {
    return direction !== this.currentPriceSort.sortDirection;
  }

  updateCurrentPriceSort(priceSort: PriceSort): void {
    this.currentPriceSort = priceSort;
    this.setPriceSortButtonText();
  }

  setPriceSortButtonText(): void {
    if (this.currentPriceSort.sortDirection === PriceSortDirection.LowToHigh) {
      this.priceSortButtonText = `${this.priceSortButtonPrefixText}${this.priceLowToHighText}`;
    } else {
      this.priceSortButtonText = `${this.priceSortButtonPrefixText}${this.priceHighToLowText}`;
    }
  }

  // this is to close the sort options panel when anywhere outside that div is clicked
  @HostListener('document:click', ['$event']) onDocumentClick() {
    this.showSortOptions = false;
  }

  toggleSortOptions($event: any): void {
    $event.stopPropagation(); // stops the HostListener event from being triggered
    this.showSortOptions = !this.showSortOptions;
  }

  onPriceSortChange(direction: PriceSortDirection): void {
    if (this.isUpdatedPriceSort(direction)) {
      this.updateCurrentPriceSort(new PriceSort(direction));
      this.changePriceSorting.emit(this.currentPriceSort);
    }
  }
}
